import { Fragment } from 'react';
import { SubHeaderItem, SubHeaderLabel } from './CatalogTable.styled';

type Props = {
  items: Array<{ label: string; text: string }>;
};

const SubHeader = ({ items = [] }: Props) => {
  return (
    <SubHeaderItem>
      {items.map((item, i) => (
        <Fragment key={`subheader-${i}`}>
          <SubHeaderLabel>{item.label}</SubHeaderLabel>
          <dd>{item.text}</dd>
        </Fragment>
      ))}
    </SubHeaderItem>
  );
};

export default SubHeader;
